import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "json-tree-row"
};
const _hoisted_2 = {
    key: 0,
    class: "json-tree-key"
};
const _hoisted_3 = {
    key: 1,
    class: "json-tree-colon"
};
const _hoisted_4 = { class: "json-tree-value" };
const _hoisted_5 = {
    key: 0,
    class: "json-tree-tab"
};
const _hoisted_6 = {
    key: 1,
    class: "json-tree-newline"
};
const _hoisted_7 = ["title"];
const _hoisted_8 = {
    key: 2,
    class: "json-tree-comma"
};
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("span", { class: "json-tree-indent" }, " ", -1 /* HOISTED */);
const _hoisted_10 = {
    key: 1,
    class: "json-tree-deep"
};
import { computed } from "vue";
import JSONTreeRow from "./JSONTreeRow.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'JSONTree',
    props: {
        level: { default: Infinity },
        kv: {},
        raw: {},
        data: {},
        foldedProps: { default: () => [] },
        requireSort: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const sortedData = computed(() => {
            if (typeof props.data === "undefined") {
                return undefined;
            }
            const keys = Object.keys(props.data);
            keys.sort();
            return keys.reduce((acc, key) => {
                acc[key] = props.data[key];
                return acc;
            }, {});
        });
        const parsed = computed(() => {
            if (props.kv) {
                return props.kv;
            }
            let result;
            try {
                if (props.raw) {
                    result = JSON.parse(props.raw);
                }
                else if (typeof props.data !== "undefined") {
                    result = props.requireSort ? sortedData.value : props.data;
                }
                else {
                    result = "[Vue JSON Tree] No data passed.";
                    console.warn(result);
                }
            }
            catch (e) {
                result = "[Vue JSON Tree] Invalid raw JSON.";
            }
            finally {
                result = parse(result);
            }
            return result;
        });
        const parse = (data, depth = 0, last = true, key = undefined) => {
            const kv = { depth, last, primitive: true, key: JSON.stringify(key) };
            if (typeof data === "string") {
                const value = data
                    .replace(/\\t/g, "\t")
                    .split(/\\n/g)
                    .flatMap((line) => line.split(/\\t/g).map((segment, index, array) => ({
                    type: "string",
                    value: segment,
                    isNewLine: false,
                    isTab: index > 0 && index < array.length,
                })))
                    .map((line, index) => (Object.assign(Object.assign({}, line), { isNewLine: index > 0 })));
                return Object.assign(kv, { type: "string", value });
            }
            else if (typeof data !== "object") {
                return Object.assign(kv, {
                    type: typeof data,
                    value: [{ type: typeof data, value: JSON.stringify(data) }],
                });
            }
            else if (data === null) {
                return Object.assign(kv, {
                    type: "null",
                    value: [{ type: "null", value: "null" }],
                });
            }
            else if (Array.isArray(data)) {
                const value = data.map((item, index) => {
                    return parse(item, depth + 1, index === data.length - 1);
                });
                return Object.assign(kv, { primitive: false, type: "array", value });
            }
            else {
                const keys = Object.keys(data);
                const value = keys.map((key, index) => {
                    return parse(data[key], depth + 1, index === keys.length - 1, key);
                });
                return Object.assign(kv, { primitive: false, type: "object", value });
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass(["json-tree", { 'json-tree-root': parsed.value.depth === 0 }])
            }, [
                (parsed.value.primitive)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parsed.value.depth * 2 + 3, (n) => {
                            return (_openBlock(), _createElementBlock("span", {
                                class: "json-tree-indent",
                                key: n
                            }, " "));
                        }), 128 /* KEYED_FRAGMENT */)),
                        (parsed.value.key)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(parsed.value.key), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                        (parsed.value.key)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, ": "))
                            : _createCommentVNode("v-if", true),
                        _createElementVNode("span", _hoisted_4, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parsed.value.value, (line, index) => {
                                return (_openBlock(), _createElementBlock("span", {
                                    key: index,
                                    class: "json-tree-line"
                                }, [
                                    (line.isTab)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "    "))
                                        : _createCommentVNode("v-if", true),
                                    (line.isNewLine)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "⏎"))
                                        : _createCommentVNode("v-if", true),
                                    _createElementVNode("pre", {
                                        class: _normalizeClass(["json-tree-value", 'json-tree-value-' + parsed.value.type]),
                                        title: line.value
                                    }, _toDisplayString(line.value), 11 /* TEXT, CLASS, PROPS */, _hoisted_7)
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        (!parsed.value.last)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, ","))
                            : _createCommentVNode("v-if", true),
                        _hoisted_9
                    ]))
                    : _createCommentVNode("v-if", true),
                (!parsed.value.primitive)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                        _createVNode(JSONTreeRow, {
                            parsed: parsed.value,
                            "folded-props": _ctx.foldedProps,
                            level: _ctx.level
                        }, null, 8 /* PROPS */, ["parsed", "folded-props", "level"])
                    ]))
                    : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */));
        };
    }
});
